"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceTypeToJSON = exports.AudienceTypeFromJSONTyped = exports.AudienceTypeFromJSON = exports.AudienceType = void 0;
/**
 * Type of the audience.
 * @export
 */
exports.AudienceType = {
    Custom: 'CUSTOM',
    Lookalike: 'LOOKALIKE'
};
function AudienceTypeFromJSON(json) {
    return AudienceTypeFromJSONTyped(json, false);
}
exports.AudienceTypeFromJSON = AudienceTypeFromJSON;
function AudienceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudienceTypeFromJSONTyped = AudienceTypeFromJSONTyped;
function AudienceTypeToJSON(value) {
    return value;
}
exports.AudienceTypeToJSON = AudienceTypeToJSON;
